import { fetcher } from '@commenda/utils';
import { TPolicyListResponse } from './types';

/** Every live policy of the company in one unpaginated read, for an export rather than a page of the list. */
export async function fetchAllPolicies(
  companyId: number
): Promise<TPolicyListResponse> {
  const response = await fetcher(
    `transfer-pricing/policy?companyId=${companyId}`,
    { method: 'GET' }
  );

  if (!response.ok) throw new Error('Could not load the policies to export.');

  return (await response.json()) as TPolicyListResponse;
}
